<template>
  <div class="container" :class="{ invisible: !visible }" v-observe-visibility="observeVisibility">
    <Flex w-full v-if="visible">
      <Flex section-progress-wrapper>
        <ProgressBar
          :percentage="progressValue"
          :color="secondaryColor"
          :title="progressBarTitle"
          class="section-progress"
        />
      </Flex>
      <FormSection class="dialog-group" :title="title" :lazy="false" collapsible :ref="title">
        <DataEntryDialog
          v-for="(item, index) in items"
          :key="item.id"
          :item="item"
          :title="getCalculatedTitle(item)"
          :alwaysVisible="alwaysVisible && index <= 5"
          :group="title"
        ></DataEntryDialog>
      </FormSection>
    </Flex>
  </div>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import FormSection from '@wizer/core/components/form/FormSection'
import events from '@wizer/core/events'
import { mapGetters } from 'vuex'
import DataEntryDialog from '@/components/sustainability/DataEntryDialog'
import ProgressBar from '@/components/sustainability/ProgressBar'
import TrackVisibility from '@/mixins/TrackVisibility'

export default {
  name: 'DialogGroup',
  components: {
    Flex,
    FormSection,
    DataEntryDialog,
    ProgressBar,
  },
  props: {
    title: String,
    items: Array,
    groupBy: String,
  },
  mixins: [TrackVisibility],
  mounted() {
    this.expand()
    events.subscribe('scroll-to-group', this.scrollTo)
  },
  methods: {
    expand() {
      if (this.visible && this.$refs[this.title]) {
        this.$refs[this.title].toggleCollapsed()
      }
    },
    getCalculatedTitle(item) {
      if (this.groupBy === 'location') {
        return item.timePeriod
      }
      if (this.groupBy === 'timePeriod') {
        return item.location
      }
      return `${item.location}, ${item.timePeriod}`
    },
    scrollTo(group) {
      if (group === this.title) {
        this.$el.scrollIntoView()
        // as items become visible they might have move a bit so do it again
        setTimeout(() => {
          this.$el.scrollIntoView()
        }, 500)
      }
    },
    visibilityChanged(visible) {
      this.visible = visible
      this.$nextTick(() => {
        this.expand()
      })
    },
  },
  computed: {
    ...mapGetters('Visualizations', ['secondaryColor']),
    ...mapGetters('SustainabilityData', ['groupProgress']),
    progressData() {
      return this.groupProgress(this.title)
    },
    progressValue() {
      return this.progressData ? this.progressData.progress : 0
    },
    progressBarTitle() {
      if (this.progressData) {
        return `${this.$t('progress')}: ${this.progressData.completed} / ${
          this.progressData.completed + this.progressData.outstanding
        }`
      }
      return ''
    },
  },
}
</script>

<style lang="postcss">
/* Can not be scoped if we want to override wizer section styling */
.dialog-group > .w-form-section__toolbar {
  @apply sticky top-0 bg-white z-10;
}
</style>

<style lang="postcss" scoped>
.section-progress-wrapper {
  @apply sticky top-0 w-0 z-20 h-10 mt-2;
  left: 70%;
}
.section-progress {
  @apply h-5 mt-5;
  min-width: 10rem;
}
.container.invisible {
  min-height: 50rem;
}
</style>
